import {
  usePortfolio,
  useReferenceData,
  useStructureGrouping,
} from "@iliotech/data-wire";
import { STRUCTURE_OPTIONS } from "@iliotech/data-wire/src/reactHooks/context/StructureGrouping/StructureGrouping";
import { IReportCell } from "@iliotech/data-wire/src/stores/ReportBespoke/ReportBespokeStore";
import React from "react";

interface IProps {
  cell: IReportCell;
  store: any;
  pageId: string;
  cellId: string;
}
export const useFakeStructureContext = ({ cell, store, ...props }: IProps) => {
  const globalStructureContext = useStructureGrouping();
  const portfolio = usePortfolio(props.pageId!);

  const custodians = portfolio?.data?.data.custodians || [];
  const { Currency } = useReferenceData();
  const structureOptions = React.useMemo(
    () => STRUCTURE_OPTIONS("RISK_ASSET_CLASS", custodians, Currency),
    [custodians, Currency]
  );

  const setCellGrouping = (newGrouping: string) => {
    const nextGroup = structureOptions.find((o) => o.key === newGrouping);
    console.log("SET CELL GROUPING");
    if (!cell.structureContext) {
      store.updateCell(props.pageId, props.cellId, "structureContext", {
        ...defaultStructureContext,
        grouping: nextGroup,
        selectedGroup: undefined,
      });
    } else {
      store.updateCell(props.pageId, props.cellId, "structureContext", {
        ...cell.structureContext,
        grouping: nextGroup,
        selectedGroup: undefined,
      });
    }
  };

  const setCellGroup = (newGroup: { code: string; label: string }) => {
    if (!cell.structureContext) {
      store.updateCell(props.pageId, props.cellId, "structureContext", {
        ...defaultStructureContext,
        selectedGroup: newGroup,
      });
    } else {
      store.updateCell(props.pageId, props.cellId, "structureContext", {
        ...cell.structureContext,
        selectedGroup: newGroup,
      });
    }
  };

  const cellStructureContext = cell.structureContext;

  const defaultStructureContext = {
    ...globalStructureContext,
    setGrouping: setCellGrouping,
    setSelectedGroup: setCellGroup,
  };
  const structureGrouping = cellStructureContext || defaultStructureContext;

  return { structureGrouping, setCellGrouping, setCellGroup };
};
